import PosterTransition from 'components/poster-transition/poster-transition';
import { GameType } from 'names/do-names';
import { BounceZoomIn, FadeIn } from 'slotworks/graphics/animation/base-animations';
import Layers from 'slotworks/graphics/layers/layers';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import Currency from 'slotworks/i18n/currency';
import soundManager from 'slotworks/sound/sound-manager';
import Contract from 'slotworks/utils/contract';
import { sequence } from 'slotworks/utils/race-utils';
import * as TweenJS from 'slotworks/utils/tween';
import GameInit from 'states/game-init';
import deviceInfo from 'slotworks/utils/device-info';
import { LimitBitmapText } from 'model/do-utils';
import PortraitMessages from 'components/messages/portrait-messages';

export default class ExitFreeSpinTransition extends AbstractSceneTransition {
    layers: any = [];
    private valueTweenObject: { value: number };
    private BOUNCE_TIME: number = 550;
    private glow: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract(resolve => {
            FadeIn(Layers.CelebrationBackground.getSprite('filter'), 400).execute();
            Layers.Prompts.getFlexiButton('continue').setEnabled(true);
            this.glow = Layers.CelebrationBackground.getSprite('DO_glow');
            this.glow.anchor.set(0.5, 0.5);
            this.glow.x += this.glow.width / 2;
            this.glow.y += this.glow.height / 2;
            const rotation = Math.PI / 64;
            this.glow.rotation = -rotation;

            BounceZoomIn(this.glow, this.BOUNCE_TIME).execute();
            BounceZoomIn(Layers.Prompts.container, this.BOUNCE_TIME)
                .then(() => {
                    GameInit.gameType = GameType.default;
                    new TweenJS.Tween(this.glow)
                        .to({ rotation }, 2000)
                        .repeat(Infinity)
                        .yoyo(true)
                        .start();
                    new TweenJS.Tween(this.glow)
                        .to({ alpha: 0.6 }, 200)
                        .repeat(Infinity)
                        .delay(100)
                        .yoyo(true)
                        .start();
                })
                .execute();
            if(!deviceInfo.isDesktop) {
                deviceInfo.onLayoutChange.add(this.onLayoutChange);
            }
            resolve(null);
            this.startCountUp(GameInit.freeSpinsWin);
        });
    }

    private onLayoutChange = () => {
        const position = Layers.CelebrationBackground.getPosition("DO_glow");
        this.glow.position.set(position.x + position.width/2, position.y + position.height/2);
    }

    private startCountUp(amount: number) {
        let valueText: PIXI.extras.BitmapText;
        this.valueTweenObject = { value: 0 };
        const countTween: TweenJS.Tween = new TweenJS.Tween(this.valueTweenObject);
        soundManager.customEvent('winnings_countup');

        const update = () => {
            if (valueText) {
                valueText.text = Currency.format(this.valueTweenObject.value, undefined, undefined, true, true);
                
                LimitBitmapText(valueText, Layers.Prompts.getPosition("limits"));
            }
        };

        const complete = () => {
            soundManager.customEvent('winnings_countup_end');
            if (valueText) valueText.text = Currency.format(amount, undefined, undefined, true);
        };

        const setup = () => {
            valueText = Layers.Prompts.getBitmapText('value');
            if (valueText) valueText.text = '';
        };

        let tween = countTween;
        countTween.to({ value: 0 }, 0);
        tween.chain(
            new TweenJS.Tween(this.valueTweenObject)
                .to({ value: amount }, 1500)
                .onUpdate(update)
                .onComplete(complete)
        );
        countTween.start();
        setup();
    }

    public out(): Contract<void> {
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.remove(this.onLayoutChange);
        }
        TweenJS.removeAll(this.glow);
        return sequence([
            () => PosterTransition.start(),
            () =>
                Contract.wrap(() => {
                    soundManager.customEvent("start_background_ambience");    
                    Layers.Prompts.container.children.map(el => (el.visible = false));
                    Layers.CelebrationBackground.getSprite('DO_glow').visible = false;
                    Layers.CelebrationBackground.getSprite('filter').visible = false;
                    PortraitMessages.setDefault();
                    PortraitMessages.show();
                }),
            () => PosterTransition.end()
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/transitions/exit-freespin-transition.ts